// src/pages/PublicationsPage.tsx
import React, { useState, useEffect } from 'react';
import { getPublications, Publication } from '../api/publicationService';
import './PublicationsPage.css';

const PublicationsPage: React.FC = () => {
  const [publications, setPublications] = useState<Publication[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchPublications = async () => {
      try {
        const data = await getPublications();
        // Sort publications by year (newest first)
        const sortedData = [...data].sort((a, b) => b.year - a.year);
        setPublications(sortedData);
      } catch (err: any) {
        console.error('Error fetching publications:', err);
        setError(`Failed to load publications: ${err.message}`);
      } finally {
        setLoading(false);
      }
    };

    fetchPublications();
  }, []);

  // Group publications by year
  const publicationsByYear = publications.reduce((acc, pub) => {
    const year = pub.year.toString();
    if (!acc[year]) {
      acc[year] = [];
    }
    acc[year].push(pub);
    return acc;
  }, {} as Record<string, Publication[]>);

  // Get years in descending order
  const years = Object.keys(publicationsByYear).sort((a, b) => parseInt(b) - parseInt(a));

  if (loading) return <div className="publications-container"><p>Loading publications...</p></div>;
  if (error) return <div className="publications-container"><p className="error">{error}</p></div>;

  return (
    <div className="publications-container">
      <h1>Publications</h1>
      
      {publications.length === 0 ? (
        <p>No publications found.</p>
      ) : (
        years.map(year => (
          <div key={year} className="publication-year">
            <h2>{year}</h2>
            <div className="publications-list">
              {publicationsByYear[year].map(publication => (
                <div key={publication.id} className="publication-item">
                  <h3 className="publication-title">{publication.title}</h3>
                  {publication.link ? (
                    <a 
                      href={publication.link} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="publication-link"
                    >
                      View Publication
                    </a>
                  ) : null}
                </div>
              ))}
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export default PublicationsPage;
